import withAuthentication from '../HOC/withAuthentication';
import withoutAuthentication from '../HOC/withoutAuthentication';
import EditAdminScreen from '../screens/edit-admin';
import EditInspectorScreen from '../screens/edit-inspector';
import EditSupervisorScreen from '../screens/edit-supervisor';

import {
	LoginScreen,
	ResetPasswordScreen,
	AdminsScreen,
	NewAdminScreen,

	InspectorsScreen,
	NewInspectorScreen,
	ResetPasswordInspectorScreen,

	SupervisorsScreen,
	NewSupervisorScreen,
	ResetPasswordSupervisorScreen,

	InspectionApplicationsScreen,
	NewInspectionApplicationsScreen,
	InspectionApplicationDetailScreen,

	PageNotFound
} from '../screens';

import { SUPER_ADMIN } from '../utils/constants';
import ResetPasswordAdminScreen from '../screens/resetPassword-admin';

import {
	ADMINS_ROUTE,
	RESETPASSWORD_ADMIN_ROUTE,
	NEW_ADMIN_ROUTE,
	EDIT_ADMIN_ROUTE,

	NEW_INSPECTOR_ROUTE,
	INSPECTORS_ROUTE,
	RESETPASSWORD_INSPECTOR_ROUTE,
	EDIT_INSPECTOR_ROUTE,

	NEW_SUPERVISOR_ROUTE,
	SUPERVISORS_ROUTE,
	RESETPASSWORD_SUPERVISOR_ROUTE,
	EDIT_SUPERVISOR_ROUTE,

	LOGIN_ROUTE,
	RESET_PASSWORD_ROUTE,

	INSPECTORSAPPLICATIONS_ROUTE,
	INSPECTORSAPPLICATIONS_DETAIL_ROUTE,
	NEW_INSPECTIONAPPLICATIONS_ROUTE
} from './paths';

const routes = [
	{
		path: LOGIN_ROUTE,
		component: withoutAuthentication(LoginScreen),
		exact: true
	},
	{
		path: RESET_PASSWORD_ROUTE,
		component:  ResetPasswordScreen,
		exact: true
	},
	{
		path: ADMINS_ROUTE,
		component: withAuthentication( AdminsScreen ),
		superAdmin: true,
		exact: true
	},
	{
		path: EDIT_ADMIN_ROUTE,
		component: withAuthentication( EditAdminScreen ),
		superAdmin: true,
		exact: true
	},
	{
		path: EDIT_INSPECTOR_ROUTE,
		component: withAuthentication( EditInspectorScreen ),
		exact: true
	},
	{
		path: EDIT_SUPERVISOR_ROUTE,
		component: withAuthentication( EditSupervisorScreen ),
		exact: true
	},
	{
		path: NEW_ADMIN_ROUTE,
		component: withAuthentication( NewAdminScreen ),
		superAdmin: true,
		exact: true
	},
	{
		path: RESETPASSWORD_ADMIN_ROUTE,
		component: withAuthentication( ResetPasswordAdminScreen ),
		superAdmin: true,
		exact: true
	},
	{
		path: SUPERVISORS_ROUTE,
		component: withAuthentication( SupervisorsScreen ),
		exact: true
	},
	{
		path: NEW_SUPERVISOR_ROUTE,
		component: withAuthentication( NewSupervisorScreen ),
		exact: true
	},
	{
		path: RESETPASSWORD_SUPERVISOR_ROUTE,
		component: withAuthentication( ResetPasswordSupervisorScreen ),
		exact: true
	},
	{
		path: INSPECTORS_ROUTE,
		component: withAuthentication( InspectorsScreen ),
		exact: true
	},
	{
		path: NEW_INSPECTOR_ROUTE,
		component: withAuthentication( NewInspectorScreen ),
		exact: true
	},
	{
		path: RESETPASSWORD_INSPECTOR_ROUTE,
		component: withAuthentication( ResetPasswordInspectorScreen ),
		exact: true
	},
	{
		path: INSPECTORSAPPLICATIONS_ROUTE,
		component: withAuthentication( InspectionApplicationsScreen ),
		exact: true
	},
	{
		path: NEW_INSPECTIONAPPLICATIONS_ROUTE,
		component: withAuthentication( NewInspectionApplicationsScreen ),
		exact: true
	},
	{
		path: INSPECTORSAPPLICATIONS_DETAIL_ROUTE,
		component: withAuthentication( InspectionApplicationDetailScreen ),
		exact: true
	},
	{
		path: '*',
		component: withoutAuthentication(LoginScreen)
	}
	
];

const getRoutes = ( role ) => routes.filter( ( route ) => (
	( route.superAdmin && role === SUPER_ADMIN ) || (!route.superAdmin || (!route.login && role !== ''))) 
);

export default getRoutes;
